/**
 * customerId pre API volania na backend (access-system vouchers a súvisiace).
 * Musí zodpovedať `customerId` v uloženom používateľovi (`localStorage` kľúč `user`),
 * nie len `customer.id` / `customer._id` z auth objektu.
 *
 * @param {() => object | null | undefined} [getAuthUser] — voliteľný fallback z Jumbo auth
 * @returns {string|null}
 */
export function getLoggedInCustomerId(getAuthUser) {
  if (typeof window !== "undefined") {
    try {
      const raw = localStorage.getItem("user");
      if (raw) {
        const user = JSON.parse(raw);
        const cid = user?.customerId;
        if (cid != null && String(cid).trim() !== "") {
          return String(cid).trim();
        }
      }
    } catch (_e) {
      /* ignore malformed JSON */
    }
  }

  if (typeof getAuthUser === "function") {
    const auth = getAuthUser();
    const top = auth?.customerId;
    if (top != null && String(top).trim() !== "") {
      return String(top).trim();
    }
    const customer = auth?.customer;
    if (customer && typeof customer === "object") {
      const fallback = customer.id ?? customer._id;
      if (fallback != null && String(fallback).trim() !== "") {
        return String(fallback).trim();
      }
    }
  }

  return null;
}
